import { Box, Button, Link,useMediaQuery, Typography } from "@mui/material";
import * as React from 'react';
import { useRef, useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { setLogin } from "../../state";
import useAuth from '../../hooks/useAuth';
import axios from '../../api/axios';



const VerifyPage = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";
    const userRef = useRef();
    const errRef = useRef();
    const [errMsg, setErrMsg] = useState('');
     const { auth, setAuth, persist, setPersist } = useAuth(); 
     const dispatch = useDispatch();


    const token = searchParams.get("token");
    const email = searchParams.get("email");
    console.log(token)

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('/auth2',
                JSON.stringify({"token": token}),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                }
            );
            const data = response;
            // console.log(data);
            // console.log(JSON.stringify(response));
            const accessToken = response?.data?.accessToken;
            setAuth({ accessToken });
            dispatch(
                setLogin({
                    email: email,
                    token: accessToken
                })
            );
            // setUser('');
            // setPassword('');
            navigate('/');
        } catch (err) {
            if (!err?.response) {
                setErrMsg('No server response.');
            } else if (err.response?.status === 400) {
                setErrMsg('Missing username or password');
            } else if (err.response?.status === 401) {
                setErrMsg('Unauthorized');
            } else {
                setErrMsg('Login Failed');
            }
            setErrMsg('Login Failed');
        }
    }

    return(
        <Box display='flex' justifyContent="center" alignItems="center" minHeight="50vh">
            {/* <p>Value of token: {token}</p>
            <p>Value of email: {email}</p> */}
            <Button sx={{ ml:'5rem', mr:'5%'}} variant="contained" onClick={handleSubmit}>Complete Sign-in</Button>
        </Box>
    );
};

export default VerifyPage;
